<template>
  <div class="mx-auto w-full">
    <div class="mt-2 flex flex-col">
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="hidden lg:table-header-group">
            <tr>
              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
              >
                Nro. trámite
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
              >
                Fecha trámite
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
              >
                Fecha instrumento
              </th>

              <th
                class="hidden bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500 md:table-cell"
              >
                Tipo
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
              >
                Estado
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
              >
                Acciones
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <template v-for="(solicitud, index) in solicitudes">
              <ItemTable
                :key="index"
                :solicitud="solicitud"
                @solicitudes-updated="$emit('change')"
              />
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ItemTable from './ItemTable.vue'

export default {
  props: {
    solicitudes: { type: Array, required: true },
  },

  components: { ItemTable },

  data() {
    return {
      isSending: false,
    }
  },
}
</script>
